import { ChangeDetectionStrategy, Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Feature, Geometry } from 'geojson';
import { Observable } from 'rxjs';
import { LocationSearchService } from './location-search.service';
import { LocationType } from './location-type.enum';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { debounceTime, filter, tap, switchMap, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationSearchComponent implements OnInit {

  @Input()
  locationTypes: LocationType[];

  @Output()
  locationSelected = new EventEmitter<Feature>();

  form: FormGroup;
  features$: Observable<Feature<Geometry, any>[]>;
  isLoading: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private locationSearchService: LocationSearchService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      search: ['', Validators.required]
    });

    this.features$ = this.form.get('search').valueChanges.pipe(
      debounceTime(500),
      this.filterInput(),
      this.search()
    );
  }

  selected(feature: any) {
    this.locationSelected.emit(feature);
  }

  displayLabel(feature: any): string {
    return feature.place_name;
  }

  private filterInput() {
    return filter(value => {
      if (typeof value === 'string') {
        return value.trim().length > 2;
      }
      return false;
    });
  }

  private search() {
    return switchMap((text: string) => {
      this.isLoading = true;
      return this.locationSearchService.search(text.toLocaleLowerCase(), this.locationTypes)
        .pipe(finalize(() => this.isLoading = false));
    });
  }

}
